import ErrorBoundary from "@/components/shared/ErrorBoundary";
import { InternalTimeEntriesView } from "@/components/project/InternalTimeEntriesView";
import { MyTasksList } from "@/components/time-registration/MyTasksList";
import { useProjectDetailContext } from "@/contexts/ProjectDetailContext";
import { useImpersonation } from "@/contexts/ImpersonationContext";
import { usePermissions } from "@/hooks/use-permissions";

export default function OverviewPage() {
  const { project } = useProjectDetailContext();
  const { activeUser } = useImpersonation();
  const { isAdmin, isSuperadmin } = usePermissions();

  // VIB-1149: T&M (hourly) prosjekter har ingen oppgaver — vis samme loggede-
  // timer-oversikt (per ansatt + totaler) som internprosjekt (VIB-795).
  if (project.is_internal || project.project_type === "hourly") {
    return (
      <ErrorBoundary>
        <InternalTimeEntriesView
          projectId={project.id}
          viewerUserId={activeUser?.id ?? null}
          canSeeAll={isAdmin || isSuperadmin}
        />
      </ErrorBoundary>
    );
  }

  return (
    <ErrorBoundary>
      <MyTasksList projectId={project.id} />
    </ErrorBoundary>
  );
}
